import type { Option } from "@tento-lona/sheets";
import { SheetColumn } from "./sheet-column.ts";

/**
 * A rendered column's cells as the sheet's own `SheetColumn`s. The column
 * layout builds every column from `createColumn` (`SheetColumn.make`) and hands
 * them back typed `HTMLElement`; a header or body that is not a `SheetColumn`
 * is not one of this sheet's columns (throws). No footer is `null`.
 */
export function sheetColumnsOf(item: {
  readonly $header: HTMLElement;
  readonly $body: HTMLElement;
  readonly $footer?: HTMLElement | null | undefined;
}): { $header: SheetColumn; $body: SheetColumn; $footer: Option<SheetColumn> } {
  const { $header, $body, $footer } = item;
  if (!($header instanceof SheetColumn) || !($body instanceof SheetColumn)) {
    throw new TypeError("sheet: a rendered column is not a SheetColumn (the layout builds each from createColumn)");
  }
  return { $header, $body, $footer: $footer instanceof SheetColumn ? $footer : null };
}
